import { languages } from "./languages"

export const DEFAULT_ADMIN_LANGUAGE = "en" as const

export const ADMIN_LANGUAGE_CODES = ["en", "vi"] as const

export type AdminLanguageCode = (typeof ADMIN_LANGUAGE_CODES)[number]

const SUPPORTED_LANGUAGE_SET = new Set<string>(ADMIN_LANGUAGE_CODES)

export const normalizeAdminLanguageCode = (
  code?: string | null
): AdminLanguageCode => {
  const normalized = String(code || "").toLowerCase()

  if (normalized === "vi" || normalized.startsWith("vi")) {
    return "vi"
  }

  return DEFAULT_ADMIN_LANGUAGE
}

export const isAdminLanguageSupported = (
  code?: string | null
): code is AdminLanguageCode => {
  return SUPPORTED_LANGUAGE_SET.has(normalizeAdminLanguageCode(code))
}

export const ADMIN_LANGUAGE_OPTIONS = languages
  .filter((language) => SUPPORTED_LANGUAGE_SET.has(language.code))
  .sort((a, b) => a.display_name.localeCompare(b.display_name))

export const getAdminLanguageDisplayName = (code?: string | null) => {
  const normalizedCode = normalizeAdminLanguageCode(code)

  return (
    ADMIN_LANGUAGE_OPTIONS.find((language) => language.code === normalizedCode)
      ?.display_name || normalizedCode.toUpperCase()
  )
}
